<template>
    <div>
        <validation-observer ref="simpleRules">
            <!--For normal date form-->
            <div v-if="datePickerValidateOption == 0">
                <b-input-group  class="mb-1">
                    <div class="date-input-wrapper">
                        <b-form-input size="sm" v-model="newDate" type="date" @paste="copyDate" class="no-calendar"></b-form-input>
                    </div>
                    <b-input-group-append>
                        <b-form-datepicker inputmode="true" onstrainInput="false" button-variant="outline-primary" class="datepickerStyle" 
                        size="sm" v-model="newDate" defaultDate: null start-weekday="1"
                        reset-button today-button :label-today-button="$t('dateTime.today')" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" 
                        :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" button-only right />
                    </b-input-group-append>
                </b-input-group>
            </div>
            <!--For valid date form-->
            <div v-else-if="datePickerValidateOption == 1">
                <validation-provider #default="{ errors }" rules="required" :name="$t('others.date_is_empty')">
                    <b-input-group  class="mb-1">
                        <div class="date-input-wrapper">
                            <b-form-input size="sm" v-model="newDate" type="date" @paste="copyDate" class="no-calendar"></b-form-input>
                        </div>
                        <b-input-group-append>
                            <b-form-datepicker inputmode="true" onstrainInput="false" button-variant="outline-primary" class="datepickerStyle"
                            size="sm" v-model="newDate" defaultDate: null start-weekday="1"
                            reset-button today-button :label-today-button="$t('dateTime.today')" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                            :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" button-only right :state="errors.length > 0 ? false:null" />
                        </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger d-block">{{ errors[0] }}</small>
                </validation-provider>
            </div>
            <!--For disabled date form-->
            <div v-if="datePickerValidateOption == 2">
                <b-input-group  class="mb-1">
                    <div class="date-input-wrapper">
                        <b-form-input disabled size="sm" v-model="newDate" type="date" @paste="copyDate" class="no-calendar"></b-form-input>
                    </div>
                    <b-input-group-append>
                        <b-form-datepicker disabled inputmode="true" onstrainInput="false" button-variant="outline-primary" class="datepickerStyle" 
                        size="sm" v-model="newDate" defaultDate: null start-weekday="1"
                        reset-button today-button :label-today-button="$t('dateTime.today')" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" 
                        :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" button-only right />
                    </b-input-group-append>
                </b-input-group>
            </div>
        </validation-observer>
    </div>

</template>

<script>
import moment from 'moment';
export default {
    name:"CustomDatePicker",
    props: {
        value: { type: String},
        datePickerValidateOption: {type: Number}
    },
    // watch: {
    //     newDate(newValue) {
    //         if(newValue == '')
    //             this.$emit('input', null)
    //         else
    //             this.$emit('input', newValue)
    //     },
    //     value(newValue){
    //         if(newValue != null && newValue != this.newDate)
    //             this.newDate = newValue.split("T")[0]  
    //     }
    // },
    watch: {
        value: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    const formatted = newValue.includes("T") ? newValue.split("T")[0] : newValue
                    this.newDate = formatted
                } else {
                    this.newDate = ''
                }
            }
        },
        newDate(newValue) {
            if (!newValue)
                this.$emit('input', null)
            else
                this.$emit('input', newValue)
        }
    },
    data() {
        return {
            newDate:""
        }
    },
    methods: {
        copyDate(event){
            var date = moment(event.clipboardData.getData('text'), 'DD-MM-YYYY')
            if(moment(date).isValid())
                this.newDate = date.format('YYYY-MM-DD')
        }
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.datepickerStyle{
    max-height: 2.2em;
    font-family: fangsong;
}
/* Furkan's notes. !IMPORTANT! */
/* When we create a new datepicker in Firefox, a native datepicker is also created along with that. */
/* For our system, we have to set the type to "date". Therefore, we hide the native datepicker with using CSS. */
/* Now, we hide the native datepicker on Edge and Safari */
.no-calendar::-webkit-calendar-picker-indicator {
    display: none;
}

/* Now, we hide the native datepicker on Firefox */
.date-input-wrapper {
    flex: 1;
    overflow: hidden;
    
    .no-calendar {
        width: calc(100% + 35px);
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
}
</style>
